export default {
  API_URL: "https://xlab.agriweather.online/rice/api/",
  FULL_URL: "https://xlab.agriweather.online",

  // ------------------------------------------------------------------
  // tool function
  // ------------------------------------------------------------------

  /**
   * getAssetsURL: 根據 baseURL 取得素材位置
   * @param {string} url - 素材相對位置
   */
  getAssetsURL: function(url) {
    // if ( process.env.NODE_ENV === 'production' )
    return process.env.BASE_URL + url;
    // return '/' + url;
  },

  setAPI_BaseURL: function() {
    this.API_URL = process.env.VUE_APP_API_BASE_URL;
    this.FULL_URL = location.origin + process.env.BASE_URL;
  },

  getAPI_URL: function(action, params = {}) {
    let _URL = ""; //this.API_URL;

    switch (action) {
      case "Blossom_Dates":
        return _URL + "blossom_dates";
      case "Field_Photos":
        return _URL + "field/" + params.fieldID + "/photos";
      case "Field_Realtime":
        return _URL + "field/" + params.fieldID + "/realtime";
      case "Field_Forecasts":
        return _URL + "field/" + params.fieldID + "/forecasts";

      default:
        return _URL;
    }
  },

  checkURL: function(assetType, url) {
    if (url && url != "") return url; // url 非 undefined 且非空字串，就直接回傳該位址

    let _asset = "";
    switch (assetType) {
      // case 'coming_soon': _asset = 'img/brand/AgriComingSoon.png'; break;
      default:
        _asset = "img/photo.png";
        break;
    }
    return this.getAssetsURL(_asset);
  }
};
